// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"374b9189","498":"cd409b2b","703":"6ca298f5"}[chunkId] + ".chunk.js";
};